"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var defaultProps = {
    columns: 1,
};
exports.default = defaultProps;
//# sourceMappingURL=defaultProps.js.map